const protocol = window.location.protocol
const qiniuHost = 'https://oic74zs8j.qnssl.com/'
const opapiHost = `${protocol}//moxicopay-api-test1.xiaoxinfen.com` //新测试环境

export default{
    qiniuHost,
    opapiHost,
}


// WEBPACK FOOTER //
// ./src/config/env.config.js